import { HttpClient, JSON_STRING ,MHTTPCL} from "../../../../services/http/http-client";
import { MODIFICATION_URL, BOOKING_URL ,SETTINGS_URL} from "../../../../services/common-urls";

const CALENDAR_DATE_ID = 'calendar_date_id';

const CALENDAR_DATES = 'calendar_dates';

const FIRST_OFFER_NOTES = 'first_offer_notes';

const CALENDAR_DATE_ARTIST_ID = 'calendar_date_artist_id';

const PERFORMANCE_TYPE = 'performance_type';

const CALENDAR_DATE_ARTISTS = 'calendar_date_artists';

const RECORD = 'record';

const BOOKING_PL = '/booking.pl';

const BOOKINGS = 'bookings';

const BOOKING_CALENDAR_CUSTOM_CHECKLIST_FORM = 'booking_calendar_custom_checklist_form';

const ADD_NEW = 'add_new';

const bookingCClNameContainer = 'booking-ccl-name-container-';

const JSON_OUTPUT = 'json';

const bookings = 'bookings';

export const overviewService = {
  updateBookingOverviewNote: (kValue, value, modified = '') => {
    return HttpClient.post(MODIFICATION_URL, {
      key: CALENDAR_DATE_ID,
      kVal: kValue,
      name: 'notes',
      value: value,
      table: CALENDAR_DATES,
      modified: modified,
      output: JSON_OUTPUT
    });
  },
  updateOverviewChecklist: (kVal, name, value, key = CALENDAR_DATE_ID, table = CALENDAR_DATES) => {
    return HttpClient.post(MODIFICATION_URL, {
      kVal,
      value,
      key,
      name,
      table
    });
  },
  checkChecklistItem: (kVal, name ) => {
    return overviewService.updateOverviewChecklist(kVal, name, 1);
  },
  uncheckChecklistItem: (kVal, name ) => {
    return overviewService.updateOverviewChecklist(kVal, name, 0);
  },
  updateBookingOfferNotes: (calendarDateId, value) => {
    return HttpClient.modify(
      CALENDAR_DATE_ID, 
      calendarDateId,
      FIRST_OFFER_NOTES,
      value,
      CALENDAR_DATES
    );
  },
  updateArtistPerformanceType: (calendarDateArtistId, value) => {
    return HttpClient.modify(
      CALENDAR_DATE_ARTIST_ID,
      calendarDateArtistId,
      PERFORMANCE_TYPE,
      value,
      CALENDAR_DATE_ARTISTS
    );
  },
  updateArtistStatus: (calendarDateArtistId, bookingStatusId) => {
    
    return HttpClient.post(MODIFICATION_URL, {
      modify_type: RECORD,
      table: CALENDAR_DATE_ARTISTS,
      kVal: calendarDateArtistId,
      booking_status_id: bookingStatusId
    }).then(res => res.data);
  },
  updateArtistOfferNotes: (calendarDateArtistId, value) => {
    return HttpClient.modify(
      CALENDAR_DATE_ARTIST_ID,
      calendarDateArtistId,
      FIRST_OFFER_NOTES,
      value,
      CALENDAR_DATE_ARTISTS
    );
  },
  checkCustomChecklist:(calendarDateId, customChecklistName) => {
    return HttpClient.get(BOOKING_PL, {
      section: BOOKINGS,
      extenal_table: CALENDAR_DATES,
      external_id: calendarDateId,
      action: BOOKING_CALENDAR_CUSTOM_CHECKLIST_FORM,
      action_perform: ADD_NEW,
      container_id: `${bookingCClNameContainer}${calendarDateId}`,
      ccl_item_name_new: customChecklistName
    });
  },
  unCheckCustomChecklist: (calendarDateId, checkListId) => {
    return HttpClient.get(BOOKING_PL, {
      checklist_id: checkListId,
      section: bookings,
      action: 'booking_calendar_custom_checklist_form',
      action_perform: 'delete_name',
      container_id: `${bookingCClNameContainer}${calendarDateId}`
    });
  },
  getChecklistFinanceStatus: (calendarDateId) => {
    return HttpClient.get(BOOKING_PL, {
      section: bookings,
      action: 'calendar_bookings_overview_finance_status',
      calendar_date_id: calendarDateId
    });
  },
  findQuestionnaireData: ({
    calendar_date_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'modal_questionnaire_local_details',
    output: JSON_STRING,
    calendar_date_id,
  }),
  findCalendarDateJSON: ({
    calendar_date_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'calendar_date_json',
    output: JSON_STRING,
    calendar_date_id,
  }),
  removeCalendarDate: ({
    calendar_date_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'delete_calendar_date',
    calendar_date_id
  }),

  getQuestionnairetemplate:()=>MHTTPCL.get(SETTINGS_URL,{
    section: 'templates',
    template_key: 'promoter_questionnaire_mail',
    output: JSON_STRING,
  }),

  getCalendarDateJSON: (calendar_date_id) => MHTTPCL.get(BOOKING_URL, {
    section: 'bookings',
    action: 'calendar_date_json',
    output: JSON_STRING,
    calendar_date_id,
  }),

  getQuestionnaireData: (calendar_date_id) => MHTTPCL.get(BOOKING_URL, {
    section: 'bookings',
    action: 'modal_questionnaire_local_details',
    output: JSON_STRING,
    calendar_date_id,
  }),
  addDefaultLocalDetails: (local_details_type_ids,calendar_date_id) => MHTTPCL.post(BOOKING_URL, {
    section: 'bookings',
    action: 'add_default_local_details',
    local_details_type_ids:local_details_type_ids,
    calendar_date_id:calendar_date_id,
    output: JSON_STRING,
  }),

  getQuestionnaireLockStatusModalData: (calendar_date_id) => HttpClient.get(BOOKING_URL, {
    section: 'bookings',
    action: 'modal_questionnaire_lock_status',
    output: JSON_STRING,
    calendar_date_id,
  }),

};